import { put, takeLatest } from 'redux-saga/effects';
import { NetworkManager } from '../../api/NetworkManager';
import {
  paymentsApiCallLoadingRequest,
  paymentsApiCallSuccess,
  paymentsApiCallFailure,
} from './paymentsSlice';
import { GET_PAYMENTS_DATA } from './types';

export function* getPaymentsRequestData(action) {
  try {
    yield put(paymentsApiCallLoadingRequest(action.payload.isLoading));
    const response = yield NetworkManager.getPaymentsEncryptedData({
      token: action.payload.token,
      policyNumber: action.payload.policyNumber,
      paymentTypes: action.payload.paymentTypes,
      loanAmount: action.payload.loanAmount,
      loanInterestAmount: action.payload.loanInterestAmount,
    });
    if (response) {
      yield put(paymentsApiCallSuccess(response.data));
    }
  } catch (error) {
    yield put(paymentsApiCallFailure(error));
  }
}

export function* watchMyPayments() {
  yield takeLatest(GET_PAYMENTS_DATA, getPaymentsRequestData);
}
